import { type UseQueryResult, useQuery } from 'react-query';
import { CsBrokerTradeToolService } from '@wealthlane/api-services/wealthlane-award-service';
import { PagedResultDto_CsSellItemDto } from '@wealthlane/api-services/wealthlane-award-service/models/PagedResultDto_CsSellItemDto';

interface SellItemsFilters {
  recordTypeName?: string;
  awardType?: string;
}

const useGetCsSellItems = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  participantId?: string,
  companyId?: string,
  skipCount: number = 0,
  maxResultCount: number = 10,
  filters?: SellItemsFilters
): UseQueryResult<PagedResultDto_CsSellItemDto | undefined, unknown> => {
  const recordTypeName = filters?.recordTypeName;
  const awardType = filters?.awardType;

  return useQuery(
    [
      'getCsSellItems',
      participantId,
      companyId,
      skipCount,
      maxResultCount,
      recordTypeName,
      awardType,
    ],
    async () => {
      if (!participantId || !companyId) return undefined;
      return await handleRequest(
        CsBrokerTradeToolService.getApiAwardApiAppCsBrokerTradeToolParticipantSellItems(
          participantId,
          companyId,
          skipCount,
          maxResultCount,
          recordTypeName,
          awardType
        )
      );
    },
    {
      enabled: !!participantId && !!companyId,
    }
  );
};

export default useGetCsSellItems;
